import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Folder } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-14 relative overflow-hidden" data-id="element-375">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-electric/10 blur-[100px] rounded-full pointer-events-none" data-id="element-376"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-377">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto bg-gradient-to-b from-petroleum to-graphite border border-electric/30 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden mt-6" data-id="element-378">
          {/* Card Folder Tab */}
          <div className="absolute top-0 left-6 z-20" data-id="element-379">
            <div className="bg-electric/10 border-x border-b border-electric/30 px-4 py-1.5 rounded-b-lg backdrop-blur-sm" data-id="element-380">
              <div className="flex items-center gap-1.5" data-id="element-381">
                <Folder className="w-3.5 h-3.5 text-electric" data-id="element-382" />
                <span className="text-[11px] font-mono font-bold uppercase tracking-widest text-electric" data-id="element-383">
                  Certificado #BIBL-7D
                </span>
              </div>
            </div>
          </div>

          {/* Stamp */}
          <div className="absolute top-10 right-6 md:top-12 md:right-12 z-20 pointer-events-none select-none" style={{
          transform: 'rotate(15deg)'
        }} data-id="element-384">
            <div className="border-[3px] border-electric/40 rounded-lg px-4 py-1.5" data-id="element-385">
              <span className="text-electric/60 font-extrabold tracking-widest text-sm md:text-lg uppercase" data-id="element-386">
                Garantizado
              </span>
            </div>
          </div>

          {/* Ruled-paper lines */}
          <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
          backgroundImage: 'repeating-linear-gradient(0deg, #ffffff 0px, #ffffff 1px, transparent 1px, transparent 32px)',
          marginTop: '48px'
        }} data-id="element-387"></div>

          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-electric to-transparent" data-id="element-388"></div>

          <ShieldCheck className="w-20 h-20 text-electric mx-auto mb-6 relative z-10 mt-4" data-id="element-389" />

          <h2 className="text-3xl md:text-4xl font-extrabold mb-6 relative z-10" data-id="element-390">
            GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>

          <p className="text-lg text-textsecondary mb-8 leading-relaxed relative z-10" data-id="element-391">
            Abrís los tomos. Los usás en tu casa. Si en 7 días no es exactamente
            lo que esperabas:
            <br data-id="element-392" />
            <br data-id="element-393" />
            <span className="text-white font-medium block" data-id="element-394">
              devolución del 100% sin formularios · sin drama · sin
              explicaciones
            </span>
          </p>

          <div className="inline-flex items-center gap-2 bg-green-500/10 text-green-400 border border-green-500/20 px-6 py-3 rounded-full font-medium relative z-10 mb-8" data-id="element-395">
            <ShieldCheck className="w-5 h-5" data-id="element-396" />
            Tasa de devoluciones: menos del 1%
          </div>

          {/* Firma Line */}
          <div className="max-w-xs mx-auto mt-4 relative z-10" data-id="element-397">
            <div className="border-b border-electric/30 mb-2" data-id="element-398"></div>
            <p className="text-[10px] font-mono uppercase tracking-widest text-textsecondary" data-id="element-399">
              Firma Autorizada — Bibliotecas Digitales™
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}